import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from '../../../v2/theme'
import { ViewModelComponentProps } from '../../../utils/typeUtilities'
import SmartCarRedirect, { Props as ComponentProps } from './SmartCarRedirect'
import useViewModel from './useViewModel'

type Props = ViewModelComponentProps<ComponentProps, typeof useViewModel>

export default ({ ...props }: Props) => {
  const viewModel = useViewModel()

  return (
    <ThemeProvider theme={theme}>
      <SmartCarRedirect {...viewModel} {...props} />
    </ThemeProvider>
  )
}
